export default __webpack_public_path__ + "static/portal/img/map1.915fdcd.png";